var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado-municipios"}},[(!_vm.$vuetify.breakpoint.mobile)?[_c('desktop',{attrs:{"listadoMunicipios":_vm.listadoMunicipios}})]:[_c('mobile',{attrs:{"listadoMunicipios":_vm.listadoMunicipios}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }